import { useI18n } from "../context/I18nContext";

const Txt = ({ children = "" }) => {
  const { translate } = useI18n();
  return typeof children === "string" ? translate(children) : children;
};

export default Txt;
